import {match, Pattern} from 'ts-pattern';

import {isTimeType, TimeType} from '../../../types/TimeType';
import {getHoursAndMinutesFromTime} from './getHoursAndMinutesFromTime';

const DIGITS_ONLY_REGEX = /^\d+$/;

const normalizeDigitOnlyInput = (input: string) =>
  match(input.length)
    .with(1, 2, () => `${input.padStart(2, '0')}:00`)
    .with(3, () => `0${input.slice(0, 1)}:${input.slice(1)}`)
    .with(4, () => `${input.slice(0, 2)}:${input.slice(2)}`)
    .otherwise(() => input);

export function getTimeFromStringInput(input: string): TimeType | null {
  const trimmed = input.trim();
  const normalized = DIGITS_ONLY_REGEX.test(trimmed) ? normalizeDigitOnlyInput(trimmed) : trimmed;

  return match(getHoursAndMinutesFromTime(normalized))
    .with(Pattern.nonNullable, ({hour, minute}) => {
      const value = `${hour}:${minute}`;
      return isTimeType(value) ? value : null;
    })
    .otherwise(() => null);
}
